var map = {
	"./analytics.svg": 43013,
	"./calendar.svg": 25337,
	"./chat.svg": 6045,
	"./client.svg": 25654,
	"./clock_circle.svg": 1038,
	"./connections.svg": 95638,
	"./courses.svg": 10919,
	"./dashboard.svg": 67109,
	"./documents.svg": 11675,
	"./eWallet.svg": 94419,
	"./issue.svg": 27828,
	"./jobs.svg": 5611,
	"./members.svg": 52596,
	"./menu.svg": 59970,
	"./projects.svg": 95305,
	"./property.svg": 82252,
	"./trade-passport.svg": 79070
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81593;